import CustomizeInternalComponent from "./customize-internal";
import Editor from "./editor";

const Customize = CustomizeInternalComponent;

Customize.Editor = Editor;

export default Customize;
